import type { MeasurableGroupType } from '@upright/common/model/input/measurable-group/types';
import { hasRevenueWeights } from '@upright/common/model/input/measurable-group/weight-validators';

export function showGroupfolioHistogramBlock(groupType: MeasurableGroupType | undefined) {
  const entityIsComparable = !!groupType && !hasRevenueWeights(groupType);
  return entityIsComparable;
}
